module.exports = __webpack_public_path__ + "img/qd-img-2.a4794829.png";